import React from 'react';
import { Modal, Fade, Typography, Button } from '@material-ui/core';

const PaymentConfirmationModal = ({
  // State props
  open,
  loadingPayment,
  isProcessingPayment,
  
  // Function props
  onClose,
  onConfirm,
  
  // Component props
  iconModal,
  Backdrop,
  
  // Style props
  classes
}) => {
  const handleConfirm = async () => {
    try {
      await onConfirm();
    } catch (error) {
      console.error('Error en pago USD:', error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={open}>
        <div className={classes.modalContent}>
          <img src={iconModal} className="iconlogoModal" alt="Modal Icon" />
          <Typography
            style={{
              fontFamily: 'Sura Sans',
              fontSize: '22px',
              color: '#0033A0',
              fontWeight: '600',
              textAlign: 'center',
              marginTop: '10px'
            }}
          >
            Pago en dólares
          </Typography>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', marginTop: '10px' }}>
            El pago en Dólares solo podrá ser realizado por{' '}
            <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', fontWeight: '600' }}>
              referencia bancaria
            </span>
          </span>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1.2rem', marginTop: '1.5rem' }}>
            <Button
              onClick={onClose}
              style={{ width: '100px', height: '40px', border: '1px solid #0133A0', borderRadius: '28px' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleConfirm}
              disabled={loadingPayment || isProcessingPayment}
              style={{
                width: '92px',
                height: '40px',
                border: '1px solid #0133A0',
                borderRadius: '28px',
                backgroundColor: (loadingPayment || isProcessingPayment) ? '#CCCCCC' : '#0133A0',
                cursor: (loadingPayment || isProcessingPayment) ? 'not-allowed' : 'pointer',
                opacity: (loadingPayment || isProcessingPayment) ? 0.7 : 1
              }}
            >
              {(loadingPayment || isProcessingPayment) ? 'Procesando...' : 'Aceptar'}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default PaymentConfirmationModal;



// WEBPACK FOOTER //
// ./src/containers/client/receipts/PaymentConfirmationModal.js